import React from 'react';
import GeneralButtonComponent from '../../../components/button/GeneralButtonComponent';

type Props = {
    onclose: any
};

const TourAlertTemplate = (props: Props) => {
    return (
        <div style={{ fontSize: '13px' }}>

            <p >Te recomendamos <strong>20 minutos antes</strong> de la salida del transporte para que no haya contratiempos.</p>

            <div className='flex justify-between items-center mt-8'>
                <div className='inline-flex gap-2 items-center'> <img src="/assets/img/icons/bus-icon.svg" alt="bus" /> <strong>Salida del Transporte:</strong></div>
                <div>7:00 a.m.</div>
            </div>

            <div className='flex justify-between items-center mt-4'>
                <div className='inline-flex gap-2 items-center'> <img src="/assets/img/icons/marker-icon.svg" alt="marcador" /><strong>Punto de encuentro:</strong></div>
                <div>Lobby del Hotel</div>
            </div>

            <p className='mt-8' style={{ color: '#FF4343' }}><small>*En caso de no presentarse a tiempo no podrás recuperar el dinero con el que hiciste tu reservación. </small></p>

            <GeneralButtonComponent classes='mt-8 primary_btn hover:primary_btn text-white py-2 px-6 he-50' click={props.onclose}
                bgcolor='#67BAAF'> Aceptar </GeneralButtonComponent>
        </div>
    );
};

export default TourAlertTemplate;